import { useState } from 'react'
import { useSearchParams, Link, useNavigate } from 'react-router-dom'
import { authService } from '../services/authService'
import { useTranslation } from '../contexts/TranslationContext'

export default function ResetPassword() {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const [password, setPassword] = useState('')
  const [passwordConfirmation, setPasswordConfirmation] = useState('')
  const [email, setEmail] = useState(searchParams.get('email') || '')
  const [message, setMessage] = useState('')
  const [error, setError] = useState('')

  const token = searchParams.get('token')

  const handleReset = async (e) => {
    e.preventDefault()

    if (!token) {
      setError(t('Missing reset token', 'Missing reset token'))
      return
    }

    try {
      const response = await authService.resetPassword(email, token, password, passwordConfirmation)
      setMessage(response.message || t('Password reset successful', 'Password reset successful'))
      setError('')
      setTimeout(() => navigate('/login'), 1500)
    } catch (err) {
      setError(err.response?.data?.message || t('Reset password failed', 'Reset password failed'))
      setMessage('')
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-surface rounded-lg shadow-lg p-8">
        <h2 className="text-2xl font-bold mb-4">{t('Reset Password', 'Reset Password')}</h2>

        {message && <div className="mb-4 text-green-700 bg-green-100 border border-green-200 p-3 rounded">{message}</div>}
        {error && <div className="mb-4 text-red-700 bg-red-100 border border-red-200 p-3 rounded">{error}</div>}

        <form onSubmit={handleReset} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-foreground">{t('Email', 'Email')}</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 w-full border-outline rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground">{t('New Password', 'New Password')}</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1 w-full border-outline rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-foreground">{t('Confirm Password', 'Confirm Password')}</label>
            <input
              type="password"
              value={passwordConfirmation}
              onChange={(e) => setPasswordConfirmation(e.target.value)}
              className="mt-1 w-full border-outline rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
              required
            />
          </div>

          <button type="submit" className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded">
            {t('Reset Password', 'Reset Password')}
          </button>
        </form>

        <p className="mt-4 text-sm text-muted-foreground">
          <Link to="/login" className="text-blue-600 hover:underline">{t('Back to login', 'Back to login')}</Link>
        </p>
      </div>
    </div>
  )
}

